"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeOrgProvidedValue = exports.deserializeValue = exports.deserializeNumber = exports.deserializeFullDateStr = exports.deserializeBoolean = exports.serializeOrgProvidedValue = exports.serializeValue = void 0;
const _ = __importStar(require("lodash"));
const error_1 = require("../error");
const typeguards_1 = require("../typeguards");
const { isNil } = _;
const serializeValue = (value) => {
    if (isNil(value)) {
        return null;
    }
    if (value === '') {
        return null;
    }
    return `${value}`;
};
exports.serializeValue = serializeValue;
const serializeOrgProvidedValue = ({ orgProvidedValue, }) => ({
    ...orgProvidedValue,
    value: (0, exports.serializeValue)(orgProvidedValue.value),
});
exports.serializeOrgProvidedValue = serializeOrgProvidedValue;
const deserializeBoolean = ({ value, orgProvidedInputId, }) => {
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    throw new error_1.FinleyError(`Unable to deserialize orgProvidedValue boolean type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`);
};
exports.deserializeBoolean = deserializeBoolean;
const deserializeFullDateStr = ({ value, orgProvidedInputId, }) => {
    (0, error_1.finleyAssert)((0, typeguards_1.isFullDateStr)(value), new error_1.FinleyError(`Unable to deserialize orgProvidedValue fullDateStr type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`));
    return value;
};
exports.deserializeFullDateStr = deserializeFullDateStr;
const deserializeNumber = ({ value, orgProvidedInputId, }) => {
    (0, error_1.finleyAssert)(!_.isNil(value), `Unable to deserialize orgProvidedValue number type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`);
    const number = Number(value);
    (0, error_1.finleyAssert)(Number.isFinite(number), new error_1.FinleyError(`Unable to deserialize orgProvidedValue number type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`));
    return number;
};
exports.deserializeNumber = deserializeNumber;
const deserializeValue = ({ type, value, nullable, orgProvidedInputId, }) => {
    if (nullable && value === null) {
        return value;
    }
    switch (type) {
        case 'boolean':
            return (0, exports.deserializeBoolean)({
                value,
                orgProvidedInputId,
            });
        case 'fullDateStr':
            return (0, exports.deserializeFullDateStr)({
                value,
                orgProvidedInputId,
            });
        case 'number':
            return (0, exports.deserializeNumber)({
                value,
                orgProvidedInputId,
            });
        case 'string':
            return value;
        default:
            return (0, error_1.finleyAssertUnreachable)(type);
    }
};
exports.deserializeValue = deserializeValue;
const deserializeOrgProvidedValue = ({ orgProvidedValue, orgProvidedInput, }) => {
    const { id: orgProvidedInputId, nullable, type } = orgProvidedInput;
    const { value } = orgProvidedValue;
    return {
        ...orgProvidedValue,
        value: (0, exports.deserializeValue)({ orgProvidedInputId, value, nullable, type }),
    };
};
exports.deserializeOrgProvidedValue = deserializeOrgProvidedValue;
//# sourceMappingURL=index.js.map